import $ from 'jquery';
import slick from 'slick-carousel';

class SlickSlider {
  constructor(el, settings) {
    this.container = el;
    this.settings = settings;
    this.init();
  }

  init() {
    $(window).on('resize', e => {
      const media = matchMedia('(min-width: 1024px)').matches;
      if (media)
        $(`${this.container}`)
          .not('.slick-initialized')
          .slick(this.settings);
    });
    $(`${this.container}`).slick(this.settings);
  }
}
export default SlickSlider;
